// Toast
import store from 'app/store';
import AppToast from 'general/components/AppToast';
import DataCommonListener from 'general/listeners/DataCommonListener';
import React, { Suspense } from 'react';
import 'react-toastify/dist/ReactToastify.css';
// router
import AppDialog from 'general/components/AppDialog';
import GuestRoute from 'general/components/AppRoutes/GuestRoute';
import PrivateRoute from 'general/components/AppRoutes/PrivateRoute';
import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router-dom';
import KTPageError01 from 'general/components/OtherKeenComponents/KTPageError01';
import AppRoute from 'general/constants/AppRoute';
import ManagePaymentTransactions from 'features/ManagePaymentTransactions';
import Auth from 'features/Auth';
import ManageDealer from 'features/ManageDealer';
import ManageInvestor from 'features/ManageInvestor';
import InvestorReconciliationReport from 'features/InvestorReconciliationReport';
import InvestorGroupReconciliationReport from 'features/InvestorGroupReconciliationReport';
import GroupReconciliationReport from 'features/ReconciliationReport/GroupReconciliationReport';
import LandlordReconciliationReport from 'features/ReconciliationReport/LandlordReconciliationReport';
import ManageLandowner from 'features/ManageLandowner';
import LandownerReconciliationReport from 'features/LandownerReconciliationReport';
import AppDialogCustom from 'general/components/AppDialogCustom';
import ChargePointDetailScreen from 'features/FE/screens/ChargeConnectorDetailScreen';
import ChargePaymentQRScreen from 'features/FE/screens/ChargePaymentQRScreen';
import GuestPaymentRoute from 'general/components/AppRoutes/GuestPaymentRoute';
import ChargeTransactionDetailScreen from 'features/FE/screens/ChargeTransactionDetailScreen';
import InvestorGroupPackListScreen from 'features/ManageGroup/screens/InvestorGroupPackListScreen';
import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import AgencySaleOrderListScreen from 'features/Agency/screens/AgencySaleOrderListScreen';
import ManageAgencyTransaction from 'features/ManageAgencyTransaction';
import ManageOrder from 'features/ManageOrder';
import AgencyContractListScreen from 'features/Agency/screens/AgencyContractListScreen';
import ManageSubAgencies from 'features/ManageSubAgencies';
import ManageTransactionHistory from 'features/ManageTransactionHistory';
import InvestorGroupPackHistory from 'features/InvestorGroupPackHistory';
import ElectricityPaymentHistory from 'features/ElectricityPaymentHistory';
import ManageCommissionTransaction from 'features/ManageCommissionTransaction';
import AgencyReconciliationListScreen from 'features/Agency/screens/AgencyReconciliationListScreen';
import AgencyConfigCommissionScreen from 'features/Agency/screens/AgencyConfigCommissionScreen';
import ManageGroup from 'features/ManageGroup';
import ChargeStation from 'features/Charge/ChargeStation';
import ChargeBrand from 'features/Charge/ChargeBrand';
import ChargeIdentityPartner from 'features/Charge/ChargeIdentityPartner';
import ChargeTransaction from 'features/Charge/ChargeTransaction';
import VehicleBrand from 'features/Charge/ChargeVehicleBrand';
import ChargeVehicle from 'features/Charge/ChargeVehicle';
import ChargeRfid from 'features/Charge/ChargeRFID';
import ChargeIdentifier from 'features/Charge/ChargeIdentifier';
import ChargeDriver from 'features/Charge/ChargeDriver';
import ChargePricing from 'features/Charge/ChargePricing';
import ChargeSystemLog from 'features/Charge/ChargeSystemLog';
import ChargeDriverTopUpHistoryScreen from 'features/Charge/ChargeDriver/screens/ChargeDriverTopUpHistoryScreen';
import ChargeDashboard from 'features/Charge/ChargeDashboard';
import ChargeStationMapScreen from 'features/Charge/ChargeStation/screens/ChargeStationMapScreen';
import ChargeStationIframeMapScreen from 'features/Charge/ChargeStation/screens/ChargeStationIframeMapScreen';
import Staff from 'features/System/Staff';
import AgencyDashboard from 'features/Agency/screens/AgencyDashboard';
import PoaContractListScreen from 'features/System/Contract/screens/PoaContractListScreen';
import ChargeSOC from 'features/Charge/ChargeSOC';
import Account from 'features/Account';
import DashboardRoute from 'general/components/AppRoutes/DashboardRoute';
import AdminDashboardRoute from 'general/components/AppRoutes/AdminDashboardRoute';
import PermissionGroup from 'features/System/PermissionGroup';
import PushNotification from 'features/System/PushNotification';
import EnergyBill from 'features/Charge/ChargeEnergyBill';
import AgencyWithdrawScreen from 'features/Agency/screens/AgencyWithdrawScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import { ChargeConstants } from 'features/Charge/chargeHelper';
import { AgencyConstants } from 'features/Agency/agencyHelper';
import ReconciliationReport from 'features/ReconciliationReport';
import ManagePremises from 'features/ManagePremises';
import ChargeMaintain from 'features/Charge/ChargeMaintain';
import ChargeInstallation from 'features/Charge/ChargeInstallation';
import Tutorial from 'features/System/InstructionConfig';
import GeneralSetting from 'features/System/GeneralSetting/screens';
import AgencyPremiseOrderListScreen from 'features/Agency/screens/AgencyPremiseOrderListScreen';
import ChargePoint from 'features/Charge/ChargePoint';
import ChargeInventory from 'features/Charge/ChargeInventory';
import ManageChargePointPartner from 'features/ManageChargePointPartner';
import ChargeDriverTopupDetailScreen from 'features/FE/screens/ChargeDriverTopupDetailScreen';
import DialogTopupCompletedScreen from 'features/FE/screens/DialogTopupCompletedScreen';
import ActionLog from 'features/System/ActionLog';
import MaintainerAuth from 'features/Maintainer/MaintainerAuth';
import MaintainerDashboard from 'features/Maintainer/MaintainerDashboard';
import MaintainerReconciliationReport from 'features/Maintainer/MaintainerReconciliationReport';
import MaintainerChargeStation from 'features/Maintainer/MaintainerChargeStation';
import MaintainerChargePoint from 'features/Maintainer/MaintainerChargePoint';
import MaintainerInfo from 'features/Maintainer/MaintainerInfo';
import MaintainerTicket from 'features/Maintainer/MaintainerTicket';
import UnderDevelopmentView from 'general/components/UnderDevelopmentView';
import ManageCoinvestor from 'features/ManageCoinvestor';
import FleetInfo from 'features/Fleet/FleetInfo';
import FleetDashboard from 'features/Fleet/FleetDashboard';
import FleetDriver from 'features/Fleet/FleetDriver';
import FleetReconciliationReport from 'features/Fleet/FleetReconciliationReport';
import FleetTopupScreen from 'features/Fleet/FleetInfo/screens/FleetTopupScreen';
import FleetTransactionScreen from 'features/Fleet/FleetInfo/screens/FleetTransactionScreen';
import VoucherPartner from 'features/ManageVoucherPartner/VoucherPartner';
import VoucherBatch from 'features/ManageVoucherPartner/VoucherBatch';
import Voucher from 'features/ManageVoucherPartner/Voucher';
import VoucherPartnerDashboard from 'features/ManageVoucherPartner/VoucherPartnerDashboard';
import VoucherVehicle from 'features/ManageVoucherPartner/VoucherVehicle';

// Load BS
require('bootstrap/dist/js/bootstrap.min');
// Load KT plugins
require('assets/plugins/ktutil');
require('assets/plugins/ktmenu');
require('assets/plugins/ktoffcanvas');
require('assets/plugins/ktcookie');
require('assets/plugins/kttoggle');
// aside
require('assets/plugins/aside/aside');
require('assets/plugins/aside/aside-menu');
require('assets/plugins/aside/aside-toggle');
// header
require('assets/plugins/header/ktheader-mobile');
require('assets/plugins/header/ktheader-topbar');

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

function App() {
  return (
    <>
      {/* Router */}
      <BrowserRouter>
        {/* Suspense */}
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <DashboardRoute />
                </PrivateRoute>
              }
            />
            {/* auth */}
            <Route
              path={`${AppRoute.auth}/*`}
              element={
                <GuestRoute>
                  <Auth />
                </GuestRoute>
              }
            />

            {/* activate account */}
            <Route
              path={`${AppRoute.mobileApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />

            {/* sac khong can tai khoan */}
            <Route path={`/prepaid/qr/:chargeConnectorSerial`} element={<ChargePointDetailScreen />} />
            <Route
              path="/prepaid/qr/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path="/prepaid/qr/transaction/:chargeTransactionId"
              element={
                <GuestPaymentRoute>
                  <ChargeTransactionDetailScreen />
                </GuestPaymentRoute>
              }
            />
            <Route
              path={`${AppRoute.dashboard}/*`}
              element={
                <PrivateRoute>
                  <AdminDashboardRoute>
                    <ChargeDashboard />
                  </AdminDashboardRoute>
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.agencyDashboard}/*`}
              element={
                <PrivateRoute>
                  <AgencyDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.stationList}/*`}
              element={
                <PrivateRoute>
                  <ChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.pointList}/*`}
              element={
                <PrivateRoute>
                  <ChargePoint />
                </PrivateRoute>
              }
            />
            {/* ban do tram sac */}
            <Route
              path={`${AppRoute.stationsMap}/*`}
              element={
                <PrivateRoute>
                  <ChargeStationMapScreen />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.stationsMapIframe}/*`}
              element={<ChargeStationIframeMapScreen />}
            />

            {/* hoa don tien dien */}
            <Route
              path={`${AppRoute.energyBillList}/*`}
              element={
                <PrivateRoute>
                  <EnergyBill />
                </PrivateRoute>
              }
            />

            {/* hoa don mat bang */}
            <Route
              path={`${AppRoute.premisesList}/*`}
              element={
                <PrivateRoute>
                  <ManagePremises />
                </PrivateRoute>
              }
            />

            {/* bao tri tru sac */}
            <Route
              path={`${AppRoute.chargeMaintain}/*`}
              element={
                <PrivateRoute>
                  <ChargeMaintain />
                </PrivateRoute>
              }
            />

            {/* lap dat tru sac */}
            <Route
              path={`${AppRoute.chargeInstallation}/*`}
              element={
                <PrivateRoute>
                  <ChargeInstallation />
                </PrivateRoute>
              }
            />

            {/* quan ly phien sac */}
            <Route
              path={`${AppRoute.chargeTransactionList}/*`}
              element={
                <PrivateRoute>
                  <ChargeTransaction />
                </PrivateRoute>
              }
            />

            {/* cau hinh thong bao gui */}
            <Route
              path={`${AppRoute.pushNotificationList}/*`}
              element={
                <PrivateRoute>
                  <PushNotification />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.systemLogList}/*`}
              element={
                <PrivateRoute>
                  <ChargeSystemLog />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.inventoryList}/*`}
              element={
                <PrivateRoute>
                  <ChargeInventory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.valuationList}/*`}
              element={
                <PrivateRoute>
                  <ChargePricing />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.staffList}/*`}
              element={
                <PrivateRoute>
                  <Staff />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.tutorialList}/*`}
              element={
                <PrivateRoute>
                  <Tutorial />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.generalSetting}/*`}
              element={
                <PrivateRoute>
                  <GeneralSetting />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.actionLogList}/*`}
              element={
                <PrivateRoute>
                  <ActionLog />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen */}
            <Route
              path={`${AppRoute.staffPermissionList}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen sale */}
            <Route
              path={`${AppRoute.salePermissionList}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup
                    role={ChargeConstants.UserRole.AGENCY}
                    subRole={AgencyConstants.AgencyRole.SALE}
                  />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen doi tac */}
            <Route
              path={`${AppRoute.partnerPermissionList}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup
                    role={ChargeConstants.UserRole.AGENCY}
                    subRole={[
                      AgencyConstants.AgencyRole.GROUP,
                      AgencyConstants.AgencyRole.INVESTOR,
                      AgencyConstants.AgencyRole.COINVESTOR,
                      AgencyConstants.AgencyRole.LANDLORD,
                    ].join(',')}
                  />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen nha dau tu nhuong quyen*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestor}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen nha dau tu HTKD*/}
            <Route
              path={`${AppRoute.manageGroupPermissionInvestorGroup}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />

            {/* quan ly nhom quyen chu dat*/}
            <Route
              path={`${AppRoute.manageGroupPermissionLandlord}/*`}
              element={
                <PrivateRoute>
                  <PermissionGroup />
                </PrivateRoute>
              }
            />
            {/* quan ly giao dich thanh toan */}
            <Route
              path={`${AppRoute.managePaymentTransactions}/*`}
              element={
                <PrivateRoute>
                  <ManagePaymentTransactions />
                </PrivateRoute>
              }
            />

            {/* quan ly giao dich nap tien */}
            <Route
              path={`${AppRoute.customerTopUpHistory}/*`}
              element={
                <PrivateRoute>
                  <ChargeDriverTopUpHistoryScreen />
                </PrivateRoute>
              }
            />

            {/* chi tra hoa hong */}
            <Route
              path={`${AppRoute.commissionTransactionList}/*`}
              element={
                <PrivateRoute>
                  <ManageCommissionTransaction />
                </PrivateRoute>
              }
            />

            {/* quan ly giao dich dai ly */}
            <Route
              path={`${AppRoute.withdrawTransactionList}/*`}
              element={
                <PrivateRoute>
                  <ManageAgencyTransaction />
                </PrivateRoute>
              }
            />

            {/* quan ly dai ly */}
            <Route
              path={`${AppRoute.saleList}/*`}
              element={
                <PrivateRoute>
                  <ManageDealer />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.saleInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageDealer isSaleInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.subSaleList}/*`}
              element={
                <PrivateRoute>
                  <ManageSubAgencies role="SALE" />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.transactionHistory}/*`}
              element={
                <PrivateRoute>
                  <ManageTransactionHistory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.saleHistory}/*`}
              element={
                <PrivateRoute>
                  <ManageDealer />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyAddOrder}`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyAddOrder}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleDetailScreen showSidebar={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.orderList}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyOrderList}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.purchaseOrder}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.saleOrder}/*`}
              element={
                <PrivateRoute>
                  <ManageOrder />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.customerList}/*`}
              element={
                <PrivateRoute>
                  <ChargeDriver />
                </PrivateRoute>
              }
            />

            {/* quan ly nha dau tu */}
            <Route
              path={`${AppRoute.manageInvestor}/*`}
              element={
                <PrivateRoute>
                  <ManageInvestor />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investorList}/*`}
              element={
                <PrivateRoute>
                  <ManageInvestor />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupList}/add-order`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen removeBaseLayout={false} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupList}/*`}
              element={
                <PrivateRoute>
                  <ManageGroup />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupsList}/add-order`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageGroup isGroupInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.subGroupList}/*`}
              element={
                <PrivateRoute>
                  <ManageSubAgencies role="GROUP" />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investorsReport}/*`}
              element={
                <PrivateRoute>
                  <InvestorReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupsReport}/*`}
              element={
                <PrivateRoute>
                  <InvestorGroupReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupReport}/*`}
              element={
                <PrivateRoute>
                  <GroupReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investorInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageInvestor isInvestorInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.investmentPackList}/*`}
              element={
                <PrivateRoute>
                  <InvestorGroupPackListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.groupPackHistory}/*`}
              element={
                <PrivateRoute>
                  <InvestorGroupPackHistory />
                </PrivateRoute>
              }
            />

            {/* quan ly chu dat */}
            <Route
              path={`${AppRoute.landlordList}/*`}
              element={
                <PrivateRoute>
                  <ManageLandowner />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.landlordInfo}/*`}
              element={
                <PrivateRoute>
                  <ManageLandowner isLandlordInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.electricityPayment}/*`}
              element={
                <PrivateRoute>
                  <ElectricityPaymentHistory />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.landlordsReport}/*`}
              element={
                <PrivateRoute>
                  <LandownerReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.landlordReport}/*`}
              element={
                <PrivateRoute>
                  <LandlordReconciliationReport />
                </PrivateRoute>
              }
            />

            {/* quan ly doi tac mua tru sac */}
            <Route
              path={`${AppRoute.chargePointPartnerList}/*`}
              element={
                <PrivateRoute>
                  <ManageChargePointPartner />
                </PrivateRoute>
              }
            />


            <Route
              path={`${AppRoute.manageVehicleBrand}/*`}
              element={
                <PrivateRoute>
                  <VehicleBrand />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.vehicleList}/*`}
              element={
                <PrivateRoute>
                  <ChargeVehicle />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.rfidList}/*`}
              element={
                <PrivateRoute>
                  <ChargeRfid />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.identifierList}/*`}
              element={
                <PrivateRoute>
                  <ChargeIdentifier />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.vehicleIdentityPartnerList}/*`}
              element={
                <PrivateRoute>
                  <ChargeIdentityPartner />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.manageChargeBrand}/*`}
              element={
                <PrivateRoute>
                  <ChargeBrand />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.superDashboard}/*`}
              element={
                <PrivateRoute>
                  <ChargeSOC />
                </PrivateRoute>
              }
            />
            {/* quybka */}
            {/* agency sale add order */}
            <Route
              path={`${AppRoute.agencySaleAddOrder}`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencySaleAddOrder}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleAddOrderScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencySaleOrderList}/*`}
              element={
                <PrivateRoute>
                  <AgencySaleOrderListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencySaleOrderDetail}/:saleId`}
              element={
                <PrivateRoute>
                  <AgencySaleDetailScreen showSidebar={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.premiseOrderList}/*`}
              element={
                <PrivateRoute>
                  <AgencyPremiseOrderListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.agencyContractList}/*`}
              element={
                <PrivateRoute>
                  <AgencyContractListScreen />
                </PrivateRoute>
              }
            />

            {/* ds bao cao doi soat */}
            <Route
              path={`${AppRoute.agencyReconciliationList}`}
              element={
                <PrivateRoute>
                  <AgencyReconciliationListScreen />
                </PrivateRoute>
              }
            />

            {/* cau hinh hoa hong */}
            <Route
              path={`${AppRoute.agencyConfigCommission}/*`}
              element={
                <PrivateRoute>
                  <AgencyConfigCommissionScreen />
                </PrivateRoute>
              }
            />

            {/* hoa don tien dien */}
            <Route
              path={`${AppRoute.energyBillList}/*`}
              element={
                <PrivateRoute>
                  <EnergyBill />
                </PrivateRoute>
              }
            />

            {/* danh sach hop dong */}
            <Route
              path={`${AppRoute.contractList}/*`}
              element={
                <PrivateRoute>
                  <AgencyContractListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.poaContract}`}
              element={
                <PrivateRoute>
                  <PoaContractListScreen />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.withdrawTransaction}/*`}
              element={
                <PrivateRoute>
                  <AgencyWithdrawScreen />
                </PrivateRoute>
              }
            />

            {/* bao cao doi soat */}
            <Route
              path={`${AppRoute.reconciliationReport}/*`}
              element={
                <PrivateRoute>
                  <ReconciliationReport />
                </PrivateRoute>
              }
            />
            {/* nap tien qua ma qr */}
            <Route path={`/topup/:serialNumber`} element={<ChargeDriverTopupDetailScreen />} />
            <Route
              path="/topup/:serialNumber/payment"
              element={
                <GuestPaymentRoute>
                  <ChargePaymentQRScreen />
                </GuestPaymentRoute>
              }
            />
            <Route path={`/payment/vnpay/completed`} element={<DialogTopupCompletedScreen />} />

            {/* ---- MAINTAINER ---- */}
            {/* Maintainer auth */}
            <Route
              path={`${AppRoute.maintainerAuth}/*`}
              element={
                <GuestRoute>
                  <MaintainerAuth />
                </GuestRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerApp}/*`}
              element={
                <GuestRoute>
                  <Account />
                </GuestRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerDashboard}/*`}
              element={
                <PrivateRoute>
                  <MaintainerDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerInfo />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.maintainerInfo}/*`}
              element={
                <PrivateRoute>
                  <MaintainerInfo isMaintainerInfo={true} />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.maintainerReport}/*`}
              element={
                <PrivateRoute>
                  <MaintainerReconciliationReport />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.ticketList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerTicket />
                </PrivateRoute>
              }
            />

            <Route
              path={`${AppRoute.myTicket}/*`}
              element={
                <PrivateRoute>
                  <MaintainerTicket isMine={true} />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerStationList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerChargeStation />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.maintainerPointList}/*`}
              element={
                <PrivateRoute>
                  <MaintainerChargePoint />
                </PrivateRoute>
              }
            />
            <Route path={`${AppRoute.maintainerStationsMap}/*`} element={<ChargeStationMapScreen />} />
            <Route
              path={`${AppRoute.underDevelopment}/*`}
              element={
                <PrivateRoute>
                  <UnderDevelopmentView />
                </PrivateRoute>
              }
            />
            <Route path={`${AppRoute.fleetList}/*`} element={<FleetInfo />} />
            <Route path={`${AppRoute.fleetInfo}/*`} element={<FleetInfo isFleetInfo={true} />} />
            <Route path={`${AppRoute.driverList}/*`} element={<FleetDriver />} />
            <Route
              path={`${AppRoute.fleetReport}/*`}
              element={<FleetReconciliationReport />}
            />
            <Route path={`${AppRoute.fleetTopup}/*`} element={<FleetTopupScreen />} />
            <Route path={`${AppRoute.fleetTransaction}/*`} element={<FleetTransactionScreen />} />
            <Route path={`${AppRoute.fleetStationsMap}/*`} element={<ChargeStationMapScreen />} />

            {/* ---- DOI TAC MUA VOUCHER ---- */}
            <Route
              path={`${AppRoute.voucherPartnerDashboard}/*`}
              element={
                <PrivateRoute>
                  <VoucherPartnerDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.voucherPartnerList}/*`}
              element={
                <PrivateRoute>
                  <VoucherPartner />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.voucherPartnerInfo}/*`}
              element={
                <PrivateRoute>
                  <VoucherPartner isVoucherPartnerInfo={true} />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.voucherBatchList}/*`}
              element={
                <PrivateRoute>
                  <VoucherBatch />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.voucherList}/*`}
              element={
                <PrivateRoute>
                  <Voucher />
                </PrivateRoute>
              }
            />
            <Route
              path={`${AppRoute.voucherPartnerVehicle}/*`}
              element={
                <PrivateRoute>
                  <VoucherVehicle />
                </PrivateRoute>
              }
            />

            <Route path="*" element={<KTPageError01 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>

      {/* App Dialog */}
      <AppDialog />
      <AppDialogCustom />
      {/* Toast */}
      <AppToast />
      {/* Listener */}
      <DataCommonListener />

      {/* eKYC div */}
      <div id="eKYC_div"></div>
    </>
  );
}

export default App;
